<div class="trip-booking-participant-column fx-column">
  @if (item) {
    <div (click)='select()' class="participant-row fx-row fx-justify-space-between fx-items-center">
      <div class="fx-row fx-justify-start fx-items-center">
        <span class="ml-4 info_participant fx-row fx-justify-start fx-items-center" style="gap: 8px">
          <span class="participant_description">{{item.participant_description || item.age_range_code}}</span>
        </span>
      </div>
      <div class="fx-row fx-justify-end fx-items-center">
        <button class="page_view_btn" mat-icon-button color='accent' matTooltip='Dettaglio Partecipante'>
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  }
</div>